import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * Accessible breadcrumb trail (nav + ol). Last item is current page (no link, aria-current="page").
 * @param {{ items: Array<{ label: string, to?: string }> }} props
 */
export default function PageBreadcrumb({ items = [] }: any) {
  if (!items.length) return null;

  return (
    <nav aria-label="Breadcrumb" className="min-w-0">
      <ol className="m-0 flex list-none flex-wrap items-center gap-x-1 gap-y-1 p-0 text-sm text-slate-400">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const label = item.label || '…';

          return (
            <li key={`${index}-${label}`} className="flex min-w-0 items-center gap-1">
              {index > 0 && (
                <ChevronRight className="h-4 w-4 flex-shrink-0 text-slate-500" aria-hidden />
              )}
              {isLast || !item.to ? (
                <span
                  className="min-w-0 truncate font-medium text-slate-200"
                  aria-current={isLast ? 'page' : undefined}
                >
                  {label}
                </span>
              ) : (
                <Link
                  to={item.to}
                  className="inline-block min-w-0 max-w-full origin-left truncate rounded text-brand-purple-light transition-transform duration-200 ease-out motion-safe:hover:scale-[1.02] hover:text-brand-purple focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple/50 focus-visible:ring-offset-2 focus-visible:ring-offset-dark-base"
                >
                  {label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
